import { useRef, useState } from "react";
import { Row, Button, Typography, Popover } from "antd";
import { Formik, Form, Field } from "formik";
import { InfoCircleOutlined } from "@ant-design/icons";
import _get from "lodash/get";
import { useNavigate } from "react-router-dom";
import EmojiPicker from "emoji-picker-react";

import { TextInput, TextEditor } from "components/common";
import { useDispatch, useSelector } from "react-redux";
import BackButton from "components/BackButton";
import { createConsulateRequest } from "providers/ConsulateProvider/slice";
import { createConsulateValidate } from "./validate";
import "./styles.less";

const ConsulateCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(false);
  const isCreating = useSelector((state) =>
    _get(state, "consulate.isCreating")
  );
  const formikRef = useRef();

  const handleCreate = (values) => {
    dispatch(createConsulateRequest(values)).then((data) =>
      navigate(`/consulate/consulate_categories/${data._id}`, {
        state: { canGoBack: true },
        replace: true,
      })
    );
  };

  return (
    <div className="consulate-create-page">
      <Row className="consulate-create-header" justify="space-between">
        <Row>
          <BackButton />
          <Typography.Title level={4}>Tạo bài</Typography.Title>
        </Row>
        <Button
          loading={isCreating}
          size="large"
          type="primary"
          onClick={() => formikRef.current.handleSubmit()}
        >
          Tạo bài
        </Button>
      </Row>
      <div className="create-form-wrapper">
        <Formik
          innerRef={formikRef}
          initialValues={{
            title: "",
            emoji: "",
            url: "",
            description: "",
            contactInfo: "",
          }}
          validationSchema={createConsulateValidate}
          onSubmit={handleCreate}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <Form>
              <Row justify="space-between">
                <TextInput name="title" placeholder="Tiêu đề (*)" size="large" />
                {touched.title && errors.title && (
                  <div className="field-error-text">
                    <InfoCircleOutlined className="info-icon" />
                    {errors.title}
                  </div>
                )}
              </Row>
              <div className="extra-fields">
                <TextInput
                  name="url"
                  placeholder="URL liên kết"
                  size="large"
                />
                <div className="emoji-field">
                  <Field name="emoji">
                    {() => (
                      <Popover
                        content={
                          <EmojiPicker
                            onEmojiClick={(emojiData) => {
                              setFieldValue("emoji", emojiData.emoji);
                              setEmojiPickerOpen(false);
                            }}
                            width={320}
                            height={400}
                          />
                        }
                        trigger="click"
                        open={emojiPickerOpen}
                        onOpenChange={setEmojiPickerOpen}
                        placement="bottomLeft"
                      >
                        <div
                          className={`emoji-select${touched.emoji && errors.emoji ? " emoji-error" : ""}`}
                        >
                          {values.emoji ? (
                            <span className="emoji-value">{values.emoji}</span>
                          ) : (
                            <span className="emoji-placeholder">Biểu tượng (*)</span>
                          )}
                        </div>
                      </Popover>
                    )}
                  </Field>
                </div>
              </div>
              {touched.emoji && errors.emoji && (
                <div className="field-error-text">
                  <InfoCircleOutlined className="info-icon" />
                  {errors.emoji}
                </div>
              )}
              <TextInput
                name="contactInfo"
                placeholder="Thông tin liên hệ"
                inputType="textarea"
                className="textarea-contact"
                rows={4}
              />
              <div className="editor-wrapper">
                <TextEditor name="description" />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ConsulateCreate;
